module.exports = __webpack_public_path__ + "img/nicaragua.7b6b6764.svg";